<!-- src/views/Authenticate.vue -->
<template>
  <v-container fluid fill-height class="d-flex align-center justify-center">
    <AntLoading />
  </v-container>
</template>

<script>
import AntLoading from '@/components/AntLoading.vue';
import LocalStorageService from '@/services/local-storage';

export default {
  name: 'Authenticate',
  components: { AntLoading },

  async mounted() {
    const { token, redirect, license } = this.$route.query || {};

    // No token? Go to login, keep redirect if present
    if (!token) {
      this.$router.replace({
        name: 'Login',
        query: redirect ? { redirect } : {},
      });
      return;
    }

    try {
      // Store token (same 8h lifetime as your login flow)
      this.$store.commit('auth_success', token);
      LocalStorageService.setToken(token);
      LocalStorageService.setTokenExpiresIn(Date.now() + 8 * 60 * 60 * 1000);

      // Fetch user and route accordingly
      const user = await this.$store.dispatch('fetchAuthenticatedUser');

      // Language preference
      this.$i18n.locale = user?.language || 'en';

      // Require 2FA? Bounce to login to complete it.
      if (user?.two_factor_enabled && !user?.two_factor_verified) {
        this.$router.replace({
          name: 'Login',
          query: { ...(redirect ? { redirect } : {}) },
        });
        return;
      }

      // License selection logic
      if (!user?.licenses?.length) {
        this.$store.commit('showNotification', {
          content: 'You have no active licenses',
          color: 'error',
        });
        this.$router.replace({ name: 'Login' });
        return;
      }

      // If license is specified in query and user has it, use it
      if (license) {
        const l = user.licenses.find((x) => x.id === license);
        if (l) {
          this.$store.commit('set_license', l);
          this.$router.replace(redirect || '/dashboard');
          return;
        }
        // If specified license not found, fall through to default handling
      }

      if (user.licenses.length === 1) {
        this.$store.commit('set_license', user.licenses[0]);
        this.$router.replace(redirect || '/dashboard');
      } else {
        // Multiple licenses: go to license picker, preserve redirect
        this.$router.replace({
          name: 'Licenses',
          query: { ...(redirect ? { redirect } : {}) },
        });
      }
    } catch (e) {
      // Any failure -> go to login
      this.$store.commit('showNotification', {
        content: e?.message || 'Authentication failed',
        color: 'error',
      });
      this.$router.replace({ name: 'Login' });
    }
  },
};
</script>
